import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { JobportalAddSkillButton } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-button';
import type { AddSkillSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-dialog';
import { JobportalAddSkillDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-dialog';
import { JobportalSkillCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-skill-card';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';
import { useFormContext } from 'react-hook-form';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { FaPlusCircle } from 'react-icons/fa';
import { JobportalAddProjectDialog } from '../../jobportal/jobportal-create-curriculum/jobportal-add-project/jobportal-add-project-dialog';

export const CreateCurriculumStep7 = () => {
  const { t } = useTranslations();

  const form = useFormContext<CreateCurriculumSchema>();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const skills_projects = form.watch('skills_projects');

  const handleSkillEdit = (skill: AddSkillSchemaType) => {
    if (skill.id === undefined) return;

    const newSkills = skills_projects?.map((e: AddSkillSchemaType) => {
      if (e.id === skill.id) {
        return skill;
      }
      return e;
    });
    form.setValue('skills_projects', newSkills as any);
  };

  const handleSkillEditClick = (skill: AddSkillSchemaType) => {
    openDialog({
      id: JobportalAddProjectDialog.id,
      content: <JobportalAddProjectDialog onEdit={handleSkillEdit} dataToEdit={skill} />,
    });
  };

  const handleSkillDelete = (skill: AddSkillSchemaType) => {
    const newSkills = skills_projects?.filter((e: AddSkillSchemaType) => e.id !== skill.id);
    form.setValue('skills_projects', newSkills || []);
  };

  const handleSkillDeleteClick = (skill: AddSkillSchemaType) => {
    handleSkillDelete(skill);
  };
  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('Moje projekty')}>
        <p className="text-[#63626F]">{t('Zadajte projekty, na ktorých ste pracovali')}</p>
        <div className={cn('flex flex-col gap-2', 'ea-jobportal-add-skill__cards-wrapper')}>
          {skills_projects?.length === 0 && (
            <p className={cn('p-6 text-muted-foreground', 'text-sm')}>
              {t('Nemáte žiadne pridané projekty')}
            </p>
          )}
          {skills_projects?.map((skill: AddSkillSchemaType, index: number) => (
            <JobportalSkillCard
              key={index}
              skill={skill}
              onSkillEditClick={() => handleSkillEditClick(skill)}
              onSkillDeleteClick={() => handleSkillDeleteClick(skill)}
              showDescription
            />
          ))}
        </div>
        <JobportalAddSkillProjectsButton />
      </CreateCurriculumSection>
    </div>
  );
};

type JobportalAddSkillProjectsButtonProps = {
  className?: string;
  onJobAdded?: () => void;
};

export const JobportalAddSkillProjectsButton = (props: JobportalAddSkillProjectsButtonProps) => {
  const { t } = useTranslations();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const form = useFormContext<CreateCurriculumSchema>();

  const onAddSkillSubmit = (data: AddSkillSchemaType) => {
    let newestId = 0;
    form.getValues('skills_projects')?.forEach((skill: any) => {
      if (skill.id > newestId) {
        newestId = skill.id;
      }
    });
    const id = newestId + 1;
    form.setValue('skills_projects', [...form.getValues('skills_projects'), { ...data, id }]);
  };

  const handleAddSkillClick = () => {
    openDialog({
      id: JobportalAddProjectDialog.id,
      content: <JobportalAddProjectDialog onSubmit={onAddSkillSubmit} />,
    });
  };

  return (
    <Button
      type={'button'}
      className="flex gap-3 sm:max-w-min"
      onClick={() => handleAddSkillClick()}
    >
      <FaPlusCircle className={'h-6 w-6'} />
      <p className="whitespace-nowrap">{t('Pridať projekt')}</p>
    </Button>
  );
};
